import React, { useState, useEffect } from "react";
import { LuSearch } from "react-icons/lu";

interface SearchProps {
  placeholder: string;
  onSearch: (query: string) => void;
  debounceDelay?: number;
}

const LuSearchIcon = LuSearch as React.ElementType;

export const Search = ({
  placeholder,
  onSearch,
  debounceDelay = 300,
}: SearchProps) => {
  const [query, setQuery] = useState("");

  useEffect(() => {
    const debounceTimer = setTimeout(() => {
      if (query.length >= 3 || query.length === 0) {
        onSearch(query);
      }
    }, debounceDelay);

    return () => clearTimeout(debounceTimer);
  }, [query, debounceDelay, onSearch]);

  return (
    <div className="border text-sm bg-white shadow-sm rounded-full px-1 flex space-x-2 items-center w-full">
      <LuSearchIcon className="ml-4 text-indigo-700" />
      <input
        type="text"
        placeholder={placeholder}
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        className="bg-transparent border-none outline-none p-2 text-base w-full"
      />
    </div>
  );
};
